Namespace 'Common.Dashboard.Navbar'

class Common.Dashboard.Navbar.AccountDataView extends Backbone.View
  template: JST['backbone/templates/common/dashboard/navbar/account_data']
  className: 'nav-bar-account-badge'

  initialize: ({accountData}) ->
    @accountData = accountData

  render: ->
    @$el.html @template({
      accountImage: @_accountImage()
      name: @accountData.name
    })
    @$('.account-image').addClass('default-image') if @_isUsingDefaultImage()
    @

  _accountImage: ->
    @accountData.imageUrl || @_defaultAccountImage()

  _isUsingDefaultImage: ->
    _.isEmpty(@accountData.imageUrl)

  _defaultAccountImage: ->
    window.image_path('building.svg')
